// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { useHistory } from 'react-router-dom';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import { deleteUser as deleteReduxUser, deleteOrg } from '../../redux/actions';
// import API from '../../utils/API';
// import MobileTopBar from '../../components/common/MobileTopBar';
// import { FaArrowLeft } from "react-icons/fa";
// import { MdDelete } from 'react-icons/md';
// import { BrowserView, MobileView } from 'react-device-detect';
// import DashboardLayout from '../../components/DashboardLayout/DashboardLayout';

// const SettingsPage: React.FC = () => {
//   const reduxUser = useSelector((state: any) => state.signin);
//   const dispatch = useDispatch();
//   const history = useHistory();

//   const [formData, setFormData] = useState({
//     email: '',
//     phoneNumber: '',
//     currentPassword: '',
//     confirmPassword: '',
//     newPassword: ''
//   });

//   const [errors, setErrors] = useState<{ [key: string]: string }>({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [showCurrentPassword, setShowCurrentPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

//   useEffect(() => {
//     if (reduxUser) {
//       setFormData({
//         email: reduxUser.email || '',
//         phoneNumber: reduxUser.telephone || '',
//         currentPassword: '',
//         confirmPassword: '',
//         newPassword: ''
//       });
//       setErrors({});
//       setMessage(null);
//     }
//   }, [reduxUser]);

//   useEffect(() => {
//     if (message) {
//       const timer = setTimeout(() => {
//         setMessage(null);
//       }, 2000);
//       return () => clearTimeout(timer);
//     }
//   }, [message]);

//   const handleInputChange = (field: string, value: string) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: value
//     }));
//     if (errors[field]) {
//       setErrors(prev => ({
//         ...prev,
//         [field]: ''
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors: { [key: string]: string } = {};

//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = 'Please enter a valid email address';
//     }

//     if (formData.phoneNumber && !/^\+?[\d\s\-\(\)]+$/.test(formData.phoneNumber)) {
//       newErrors.phoneNumber = 'Please enter a valid phone number';
//     }

//     if (formData.currentPassword || formData.confirmPassword || formData.newPassword) {
//       if (!formData.currentPassword) {
//         newErrors.currentPassword = 'Current password is required to change password';
//       }
//       if (!formData.newPassword) {
//         newErrors.newPassword = 'New password is required';
//       } else if (formData.newPassword.length < 8) {
//         newErrors.newPassword = 'Password must be at least 8 characters long';
//       }
//       if (!formData.confirmPassword) {
//         newErrors.confirmPassword = 'Please confirm your new password';
//       } else if (formData.newPassword !== formData.confirmPassword) {
//         newErrors.confirmPassword = 'Passwords do not match';
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSave = async () => {
//     if (!validateForm()) return;

//     setIsLoading(true);
//     try {
//       // Update general info (email, phone) if changed
//       if (formData.email !== reduxUser.email || formData.phoneNumber !== reduxUser.telephone) {
//         const updatedUserData = {
//           _id: reduxUser._id,
//           email: formData.email,
//           telephone: formData.phoneNumber
//         };
//         await API.updateUser(updatedUserData);
//       }

//       // Update password if provided
//       if (formData.currentPassword && formData.newPassword) {
//         // First verify current password
//         const passwordCheck = await API.checkPassword(reduxUser._id, formData.currentPassword);
//         if (!passwordCheck.data.passwordMatch) {
//           setErrors(prev => ({
//             ...prev,
//             currentPassword: 'Current password is incorrect'
//           }));
//           return;
//         }

//         // Update password
//         await API.updatePassword(reduxUser._id, formData.newPassword);
//       }

//       // Show success message (modal will auto-close after 2 seconds)
//       setMessage({ type: 'success', text: 'Settings saved successfully!' });
//     } catch (error) {
//       console.error('Error saving settings:', error);
//       setMessage({ type: 'error', text: 'Error saving settings. Please try again.' });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDeleteAccount = () => {
//     setShowDeleteConfirm(true);
//   };

//   const handleConfirmDelete = async () => {
//     setShowDeleteConfirm(false);
//     try {
//       await API.deleteUser(reduxUser._id);

//       dispatch(deleteReduxUser());
//       dispatch(deleteOrg());

//       history.push('/');

//       setMessage({ type: 'success', text: 'Account deleted successfully.' });
//     } catch (error) {
//       console.error('Error deleting account:', error);
//       setMessage({ type: 'error', text: 'Error deleting account. Please try again.' });
//     }
//   };

//   const handleCancelDelete = () => {
//     setShowDeleteConfirm(false);
//   };

//   return (
//     <>
//       <BrowserView>
//         <DashboardLayout>
//           <div style={{ backgroundColor: '#fff', minHeight: '100vh' }}>
//             <div style={{
//               maxWidth: '600px',
//               margin: '0 auto',
//               backgroundColor: 'white',
//               overflow: 'hidden'
//             }}>
//               <FaArrowLeft style={{ marginLeft: "2rem", marginTop: "1rem" }} onClick={() => history.goBack()} />

//               <div style={{
//                 padding: '0px 32px 20px',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center'
//               }}>
//                 <h2 style={{
//                   margin: 0,
//                   fontSize: '24px',
//                   fontWeight: 600,
//                   color: '#111827'
//                 }}>
//                   Settings
//                 </h2>

//               </div>

//               <div style={{ padding: '0 32px' }}>
//                 <div style={{ marginBottom: '40px' }}>
//                   <h3 style={{
//                     margin: '0 0 24px 0',
//                     fontSize: '18px',
//                     fontWeight: 600,
//                     color: '#111827'
//                   }}>
//                     General info
//                   </h3>

//                   <div style={{ marginBottom: '24px' }}>
//                     <label style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       fontSize: '14px',
//                       fontWeight: 500,
//                       color: '#374151'
//                     }}>
//                       Email
//                     </label>
//                     <input
//                       type="email"
//                       value={formData.email}
//                       onChange={(e) => handleInputChange('email', e.target.value)}
//                       style={{
//                         width: '100%',
//                         padding: '5px 16px',
//                         border: `1px solid ${errors.email ? '#ef4444' : '#d1d5db'}`,
//                         borderRadius: '6px',
//                         fontSize: '14px',
//                         transition: 'border-color 0.2s, box-shadow 0.2s'
//                       }}
//                       placeholder="Enter your email"
//                     />
//                     {errors.email && <span style={{
//                       display: 'block',
//                       marginTop: '4px',
//                       fontSize: '12px',
//                       color: '#ef4444'
//                     }}>
//                       {errors.email}
//                     </span>}
//                   </div>

//                   <div style={{ marginBottom: '24px' }}>
//                     <label style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       fontSize: '14px',
//                       fontWeight: 500,
//                       color: '#374151'
//                     }}>
//                       Phone number
//                     </label>
//                     <input
//                       type="tel"
//                       value={formData.phoneNumber}
//                       onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
//                       style={{
//                         width: '100%',
//                         padding: '5px 16px',
//                         border: `1px solid ${errors.phoneNumber ? '#ef4444' : '#d1d5db'}`,
//                         borderRadius: '6px',
//                         fontSize: '14px',
//                         transition: 'border-color 0.2s, box-shadow 0.2s'
//                       }}
//                       placeholder="Enter your phone number"
//                     />
//                     {errors.phoneNumber && <span style={{
//                       display: 'block',
//                       marginTop: '4px',
//                       fontSize: '12px',
//                       color: '#ef4444'
//                     }}>
//                       {errors.phoneNumber}
//                     </span>}
//                   </div>
//                 </div>

//                 <div style={{ marginBottom: '40px' }}>
//                   <h3 style={{
//                     margin: '0 0 24px 0',
//                     fontSize: '18px',
//                     fontWeight: 600,
//                     color: '#111827'
//                   }}>
//                     Security Section
//                   </h3>

//                   <div style={{ marginBottom: '24px' }}>
//                     <label style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       fontSize: '14px',
//                       fontWeight: 500,
//                       color: '#374151'
//                     }}>
//                       Password
//                     </label>
//                     <div style={{ position: 'relative' }}>
//                       <input
//                         type={showCurrentPassword ? 'text' : 'password'}
//                         value={formData.currentPassword}
//                         onChange={(e) => handleInputChange('currentPassword', e.target.value)}
//                         style={{
//                           width: '100%',
//                           padding: '5px 16px',
//                           paddingRight: '48px',
//                           border: `1px solid ${errors.currentPassword ? '#ef4444' : '#d1d5db'}`,
//                           borderRadius: '6px',
//                           fontSize: '14px',
//                           transition: 'border-color 0.2s, box-shadow 0.2s'
//                         }}
//                         placeholder="Enter current password"
//                       />
//                       <button
//                         type="button"
//                         onClick={() => setShowCurrentPassword(!showCurrentPassword)}
//                         style={{
//                           position: 'absolute',
//                           right: '12px',
//                           top: '50%',
//                           transform: 'translateY(-50%)',
//                           background: 'none',
//                           border: 'none',
//                           cursor: 'pointer',
//                           fontSize: '16px',
//                           padding: '4px',
//                           color: '#6b7280',
//                           transition: 'color 0.2s'
//                         }}
//                       >
//                         {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
//                       </button>
//                     </div>
//                     {errors.currentPassword && <span style={{
//                       display: 'block',
//                       marginTop: '4px',
//                       fontSize: '12px',
//                       color: '#ef4444'
//                     }}>
//                       {errors.currentPassword}
//                     </span>}
//                   </div>

//                   <div style={{ marginBottom: '24px' }}>
//                     <label style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       fontSize: '14px',
//                       fontWeight: 500,
//                       color: '#374151'
//                     }}>
//                       Confirm password
//                     </label>
//                     <div style={{ position: 'relative' }}>
//                       <input
//                         type={showConfirmPassword ? 'text' : 'password'}
//                         value={formData.confirmPassword}
//                         onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
//                         style={{
//                           width: '100%',
//                           padding: '5px 16px',
//                           paddingRight: '48px',
//                           border: `1px solid ${errors.confirmPassword ? '#ef4444' : '#d1d5db'}`,
//                           borderRadius: '6px',
//                           fontSize: '14px',
//                           transition: 'border-color 0.2s, box-shadow 0.2s'
//                         }}
//                         placeholder="Confirm password"
//                       />
//                       <button
//                         type="button"
//                         onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                         style={{
//                           position: 'absolute',
//                           right: '12px',
//                           top: '50%',
//                           transform: 'translateY(-50%)',
//                           background: 'none',
//                           border: 'none',
//                           cursor: 'pointer',
//                           fontSize: '16px',
//                           padding: '4px',
//                           color: '#6b7280',
//                           transition: 'color 0.2s'
//                         }}
//                       >
//                         {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                       </button>
//                     </div>
//                     {errors.confirmPassword && <span style={{
//                       display: 'block',
//                       marginTop: '4px',
//                       fontSize: '12px',
//                       color: '#ef4444'
//                     }}>
//                       {errors.confirmPassword}
//                     </span>}
//                   </div>

//                   <div style={{ marginBottom: '24px' }}>
//                     <label style={{
//                       display: 'block',
//                       marginBottom: '8px',
//                       fontSize: '14px',
//                       fontWeight: 500,
//                       color: '#374151'
//                     }}>
//                       New password
//                     </label>
//                     <div style={{ position: 'relative' }}>
//                       <input
//                         type={showNewPassword ? 'text' : 'password'}
//                         value={formData.newPassword}
//                         onChange={(e) => handleInputChange('newPassword', e.target.value)}
//                         style={{
//                           width: '100%',
//                           padding: '5px 16px',
//                           paddingRight: '48px',
//                           border: `1px solid ${errors.newPassword ? '#ef4444' : '#d1d5db'}`,
//                           borderRadius: '6px',
//                           fontSize: '14px',
//                           transition: 'border-color 0.2s, box-shadow 0.2s'
//                         }}
//                         placeholder="Enter a strong password"
//                       />
//                       <button
//                         type="button"
//                         onClick={() => setShowNewPassword(!showNewPassword)}
//                         style={{
//                           position: 'absolute',
//                           right: '12px',
//                           top: '50%',
//                           transform: 'translateY(-50%)',
//                           background: 'none',
//                           border: 'none',
//                           cursor: 'pointer',
//                           fontSize: '16px',
//                           padding: '4px',
//                           color: '#6b7280',
//                           transition: 'color 0.2s'
//                         }}
//                       >
//                         {showNewPassword ? <FaEyeSlash /> : <FaEye />}
//                       </button>
//                     </div>
//                     {errors.newPassword && <span style={{
//                       display: 'block',
//                       marginTop: '4px',
//                       fontSize: '12px',
//                       color: '#ef4444'
//                     }}>
//                       {errors.newPassword}
//                     </span>}
//                   </div>
//                 </div>
//               </div>

//               {/* Footer */}
//               <div style={{
//                 padding: '20px 32px',
//                 display: 'flex',
//                 gap: '12px',
//                 justifyContent: 'center'
//               }}>
//                 <button
//                   onClick={handleSave}
//                   disabled={isLoading}
//                   style={{
//                     padding: '4px 24px',
//                     borderRadius: '25px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     cursor: isLoading ? 'not-allowed' : 'pointer',
//                     backgroundColor: '#5271FF',
//                     color: 'white',
//                     border: '1px solid #5271FF',
//                     transition: 'all 0.2s',
//                     opacity: isLoading ? 0.5 : 1,
//                     minWidth: '100px'
//                   }}
//                 >
//                   {isLoading ? 'Saving...' : 'Save Changes'}
//                 </button>
//                 <button
//                   onClick={() => history.goBack()}
//                   disabled={isLoading}
//                   style={{
//                     padding: '4px 24px',
//                     borderRadius: '25px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     cursor: isLoading ? 'not-allowed' : 'pointer',
//                     backgroundColor: '#5271FF',
//                     border: "1px solid #5271FF",
//                     color: 'white',
//                     transition: 'all 0.2s',
//                     opacity: isLoading ? 0.5 : 1,
//                     minWidth: '100px'
//                   }}
//                 >
//                   Close
//                 </button>
//               </div>

//               <div style={{
//                 padding: '16px 32px 0px',

//                 textAlign: 'center'
//               }}>
//                 <button
//                   onClick={handleDeleteAccount}
//                   style={{
//                     background: 'none',
//                     border: 'none',
//                     color: '#6b7280',
//                     fontSize: '14px',
//                     display: 'flex',
//                     justifyContent: "center",
//                     alignItems: "center",

//                     cursor: 'pointer',
//                     textDecoration: 'underline',
//                     padding: '8px',
//                     transition: 'color 0.2s'
//                   }}
//                 >
//                   <MdDelete style={{ fontSize: "17px" }} /> Delete account
//                 </button>
//               </div>
//             </div>

//             {message && (
//               <div style={{
//                 position: 'fixed',
//                 top: '20px',
//                 right: '20px',
//                 padding: '16px 24px',
//                 borderRadius: '8px',
//                 color: 'white',
//                 fontWeight: 500,
//                 fontSize: '14px',
//                 boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
//                 zIndex: 1001,
//                 backgroundColor: message.type === 'success' ? '#10b981' : '#ef4444',
//                 animation: 'slideInRight 0.3s ease-out'
//               }}>
//                 <span>{message.text}</span>
//               </div>
//             )}

//             {showDeleteConfirm && (
//               <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 zIndex: 1002,
//                 padding: '20px'
//               }}>
//                 <div style={{
//                   background: 'white',
//                   borderRadius: '8px',
//                   width: '100%',
//                   maxWidth: '400px',
//                   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
//                   animation: 'fadeInScale 0.2s ease-out'
//                 }}>
//                   <div style={{
//                     padding: '24px 32px 20px',
//                     borderBottom: '1px solid #e5e7eb',
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center'
//                   }}>
//                     <h3 style={{
//                       margin: 0,
//                       fontSize: '20px',
//                       fontWeight: 600,
//                       color: '#111827'
//                     }}>
//                       Delete Account
//                     </h3>
//                     <button
//                       onClick={handleCancelDelete}
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         fontSize: '20px',
//                         cursor: 'pointer',
//                         color: '#6b7280',
//                         padding: 0,
//                         width: '32px',
//                         height: '32px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         borderRadius: '4px',
//                         transition: 'background-color 0.2s'
//                       }}
//                     >
//                       ✕
//                     </button>
//                   </div>
//                   <div style={{ padding: '32px' }}>
//                     <p style={{
//                       margin: 0,
//                       fontSize: '16px',
//                       color: '#374151',
//                       lineHeight: '1.5'
//                     }}>
//                       Are you sure you want to delete your account? This action cannot be undone and will permanently delete all your data.
//                     </p>
//                   </div>
//                   <div style={{
//                     padding: '20px 32px 24px',
//                     display: 'flex',
//                     gap: '12px',
//                     justifyContent: 'center'
//                   }}>
//                     <button
//                       onClick={handleCancelDelete}
//                       style={{
//                         padding: '4px 20px',
//                         borderRadius: '25px',
//                         fontSize: '14px',
//                         fontWeight: 500,
//                         cursor: 'pointer',
//                         backgroundColor: '#5271FF',
//                         color: '#fff',
//                         border: '1px solid #5271FF',
//                         transition: 'all 0.2s',
//                         minWidth: '80px'
//                       }}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       onClick={handleConfirmDelete}
//                       style={{
//                         padding: '4px 20px',
//                         borderRadius: '25px',
//                         fontSize: '14px',
//                         fontWeight: 500,
//                         cursor: 'pointer',
//                         backgroundColor: '#5271FF',
//                         color: 'white',
//                         border: '1px solid #5271FF',
//                         transition: 'all 0.2s',
//                         minWidth: '80px'
//                       }}
//                     >
//                       Delete Account
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div style={{ height: '80px' }}></div>
//           </div>
//         </DashboardLayout>
//       </BrowserView>
//       <MobileView>
//         <MobileTopBar />
//         <div style={{ 
//           backgroundColor: '#fff', 
//           minHeight: '100vh',
//           marginTop:'-56px',
//           background:'#fff',
//           position:'relative',
//           zIndex:9999
//           }}>
//           <div style={{
//             maxWidth: '600px',
//             margin: '0 auto',
//             backgroundColor: 'white',
//             overflow: 'hidden'
//           }}>
//             <FaArrowLeft style={{ marginLeft: "2rem", marginTop: "2rem" }} onClick={() => history.goBack()} />

//             <div style={{
//               padding: '0px 32px 20px',
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center'
//             }}>
//               <h2 style={{
//                 margin: 0,
//                 fontSize: '24px',
//                 fontWeight: 600,
//                 color: '#111827'
//               }}>
//                 Settings
//               </h2>

//             </div>

//             <div style={{ padding: '0 32px' }}>
//               <div style={{ marginBottom: '40px' }}>
//                 <h3 style={{
//                   margin: '0 0 24px 0',
//                   fontSize: '18px',
//                   fontWeight: 600,
//                   color: '#111827'
//                 }}>
//                   General info
//                 </h3>

//                 <div style={{ marginBottom: '24px' }}>
//                   <label style={{
//                     display: 'block',
//                     marginBottom: '8px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     color: '#374151'
//                   }}>
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     value={formData.email}
//                     onChange={(e) => handleInputChange('email', e.target.value)}
//                     style={{
//                       width: '100%',
//                       padding: '5px 16px',
//                       border: `1px solid ${errors.email ? '#ef4444' : '#d1d5db'}`,
//                       borderRadius: '6px',
//                       fontSize: '14px',
//                       transition: 'border-color 0.2s, box-shadow 0.2s'
//                     }}
//                     placeholder="Enter your email"
//                   />
//                   {errors.email && <span style={{
//                     display: 'block',
//                     marginTop: '4px',
//                     fontSize: '12px',
//                     color: '#ef4444'
//                   }}>
//                     {errors.email}
//                   </span>}
//                 </div>

//                 <div style={{ marginBottom: '24px' }}>
//                   <label style={{
//                     display: 'block',
//                     marginBottom: '8px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     color: '#374151'
//                   }}>
//                     Phone number
//                   </label>
//                   <input
//                     type="tel"
//                     value={formData.phoneNumber}
//                     onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
//                     style={{
//                       width: '100%',
//                       padding: '5px 16px',
//                       border: `1px solid ${errors.phoneNumber ? '#ef4444' : '#d1d5db'}`,
//                       borderRadius: '6px',
//                       fontSize: '14px',
//                       transition: 'border-color 0.2s, box-shadow 0.2s'
//                     }}
//                     placeholder="Enter your phone number"
//                   />
//                   {errors.phoneNumber && <span style={{
//                     display: 'block',
//                     marginTop: '4px',
//                     fontSize: '12px',
//                     color: '#ef4444'
//                   }}>
//                     {errors.phoneNumber}
//                   </span>}
//                 </div>
//               </div>

//               <div style={{ marginBottom: '40px' }}>
//                 <h3 style={{
//                   margin: '0 0 24px 0',
//                   fontSize: '18px',
//                   fontWeight: 600,
//                   color: '#111827'
//                 }}>
//                   Security Section
//                 </h3>

//                 <div style={{ marginBottom: '24px' }}>
//                   <label style={{
//                     display: 'block',
//                     marginBottom: '8px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     color: '#374151'
//                   }}>
//                     Password
//                   </label>
//                   <div style={{ position: 'relative' }}>
//                     <input
//                       type={showCurrentPassword ? 'text' : 'password'}
//                       value={formData.currentPassword}
//                       onChange={(e) => handleInputChange('currentPassword', e.target.value)}
//                       style={{
//                         width: '100%',
//                         padding: '5px 16px',
//                         paddingRight: '48px',
//                         border: `1px solid ${errors.currentPassword ? '#ef4444' : '#d1d5db'}`,
//                         borderRadius: '6px',
//                         fontSize: '14px',
//                         transition: 'border-color 0.2s, box-shadow 0.2s'
//                       }}
//                       placeholder="Enter current password"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowCurrentPassword(!showCurrentPassword)}
//                       style={{
//                         position: 'absolute',
//                         right: '12px',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '16px',
//                         padding: '4px',
//                         color: '#6b7280',
//                         transition: 'color 0.2s'
//                       }}
//                     >
//                       {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
//                     </button>
//                   </div>
//                   {errors.currentPassword && <span style={{
//                     display: 'block',
//                     marginTop: '4px',
//                     fontSize: '12px',
//                     color: '#ef4444'
//                   }}>
//                     {errors.currentPassword}
//                   </span>}
//                 </div>

//                 <div style={{ marginBottom: '24px' }}>
//                   <label style={{
//                     display: 'block',
//                     marginBottom: '8px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     color: '#374151'
//                   }}>
//                     Confirm password
//                   </label>
//                   <div style={{ position: 'relative' }}>
//                     <input
//                       type={showConfirmPassword ? 'text' : 'password'}
//                       value={formData.confirmPassword}
//                       onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
//                       style={{
//                         width: '100%',
//                         padding: '5px 16px',
//                         paddingRight: '48px',
//                         border: `1px solid ${errors.confirmPassword ? '#ef4444' : '#d1d5db'}`,
//                         borderRadius: '6px',
//                         fontSize: '14px',
//                         transition: 'border-color 0.2s, box-shadow 0.2s'
//                       }}
//                       placeholder="Confirm password"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                       style={{
//                         position: 'absolute',
//                         right: '12px',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '16px',
//                         padding: '4px',
//                         color: '#6b7280',
//                         transition: 'color 0.2s'
//                       }}
//                     >
//                       {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                     </button>
//                   </div>
//                   {errors.confirmPassword && <span style={{
//                     display: 'block',
//                     marginTop: '4px',
//                     fontSize: '12px',
//                     color: '#ef4444'
//                   }}>
//                     {errors.confirmPassword}
//                   </span>}
//                 </div>

//                 <div style={{ marginBottom: '24px' }}>
//                   <label style={{
//                     display: 'block',
//                     marginBottom: '8px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     color: '#374151'
//                   }}>
//                     New password
//                   </label>
//                   <div style={{ position: 'relative' }}>
//                     <input
//                       type={showNewPassword ? 'text' : 'password'}
//                       value={formData.newPassword}
//                       onChange={(e) => handleInputChange('newPassword', e.target.value)}
//                       style={{
//                         width: '100%',
//                         padding: '5px 16px',
//                         paddingRight: '48px',
//                         border: `1px solid ${errors.newPassword ? '#ef4444' : '#d1d5db'}`,
//                         borderRadius: '6px',
//                         fontSize: '14px',
//                         transition: 'border-color 0.2s, box-shadow 0.2s'
//                       }}
//                       placeholder="Enter a strong password"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowNewPassword(!showNewPassword)}
//                       style={{
//                         position: 'absolute',
//                         right: '12px',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '16px',
//                         padding: '4px',
//                         color: '#6b7280',
//                         transition: 'color 0.2s'
//                       }}
//                     >
//                       {showNewPassword ? <FaEyeSlash /> : <FaEye />}
//                     </button>
//                   </div>
//                   {errors.newPassword && <span style={{
//                     display: 'block',
//                     marginTop: '4px',
//                     fontSize: '12px',
//                     color: '#ef4444'
//                   }}>
//                     {errors.newPassword}
//                   </span>}
//                 </div>
//               </div>
//             </div>

//             {/* Footer */}
//             <div style={{
//               padding: '20px 32px',
//               display: 'flex',
//               gap: '12px',
//               justifyContent: 'center'
//             }}>
//               <button
//                 onClick={handleSave}
//                 disabled={isLoading}
//                 style={{
//                   padding: '4px 24px',
//                   borderRadius: '6px',
//                   fontSize: '14px',
//                   fontWeight: 500,
//                   cursor: isLoading ? 'not-allowed' : 'pointer',
//                   backgroundColor: '#4874cd',
//                   color: 'white',
//                   border: '1px solid #4874cd',
//                   transition: 'all 0.2s',
//                   opacity: isLoading ? 0.5 : 1,
//                   minWidth: '100px'
//                 }}
//               >
//                 {isLoading ? 'Saving...' : 'Save Changes'}
//               </button>
//               <button
//                 onClick={() => history.goBack()}
//                 disabled={isLoading}
//                 style={{
//                   padding: '4px 24px',
//                   borderRadius: '6px',
//                   fontSize: '14px',
//                   fontWeight: 500,
//                   cursor: isLoading ? 'not-allowed' : 'pointer',
//                   backgroundColor: '#4874cd',
//                   border: "1px solid #4874cd",
//                   color: 'white',
//                   transition: 'all 0.2s',
//                   opacity: isLoading ? 0.5 : 1,
//                   minWidth: '100px'
//                 }}
//               >
//                 Close
//               </button>
//             </div>

//             <div style={{
//               padding: '16px 32px 0px',

//               textAlign: 'center'
//             }}>
//               <button
//                 onClick={handleDeleteAccount}
//                 style={{
//                   background: 'none',
//                   border: 'none',
//                   color: '#6b7280',
//                   fontSize: '14px',
//                   display: 'flex',
//                   justifyContent: "center",
//                   alignItems: "center",

//                   cursor: 'pointer',
//                   textDecoration: 'underline',
//                   padding: '8px',
//                   transition: 'color 0.2s'
//                 }}
//               >
//                 <MdDelete style={{ fontSize: "17px" }} /> Delete account
//               </button>
//             </div>
//           </div>

//           {message && (
//             <div style={{
//               position: 'fixed',
//               top: '20px',
//               right: '20px',
//               padding: '16px 24px',
//               borderRadius: '8px',
//               color: 'white',
//               fontWeight: 500,
//               fontSize: '14px',
//               boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
//               zIndex: 1001,
//               backgroundColor: message.type === 'success' ? '#10b981' : '#ef4444',
//               animation: 'slideInRight 0.3s ease-out'
//             }}>
//               <span>{message.text}</span>
//             </div>
//           )}

//           {showDeleteConfirm && (
//             <div style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               zIndex: 1002,
//               padding: '20px'
//             }}>
//               <div style={{
//                 background: 'white',
//                 borderRadius: '8px',
//                 width: '100%',
//                 maxWidth: '400px',
//                 boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
//                 animation: 'fadeInScale 0.2s ease-out'
//               }}>
//                 <div style={{
//                   padding: '24px 32px 20px',
//                   borderBottom: '1px solid #e5e7eb',
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center'
//                 }}>
//                   <h3 style={{
//                     margin: 0,
//                     fontSize: '20px',
//                     fontWeight: 600,
//                     color: '#111827'
//                   }}>
//                     Delete Account
//                   </h3>
//                   <button
//                     onClick={handleCancelDelete}
//                     style={{
//                       background: 'none',
//                       border: 'none',
//                       fontSize: '20px',
//                       cursor: 'pointer',
//                       color: '#6b7280',
//                       padding: 0,
//                       width: '32px',
//                       height: '32px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       borderRadius: '4px',
//                       transition: 'background-color 0.2s'
//                     }}
//                   >
//                     ✕
//                   </button>
//                 </div>
//                 <div style={{ padding: '32px' }}>
//                   <p style={{
//                     margin: 0,
//                     fontSize: '16px',
//                     color: '#374151',
//                     lineHeight: '1.5'
//                   }}>
//                     Are you sure you want to delete your account? This action cannot be undone and will permanently delete all your data.
//                   </p>
//                 </div>
//                 <div style={{
//                   padding: '20px 32px 24px',
//                   display: 'flex',
//                   gap: '12px',
//                   justifyContent: 'center'
//                 }}>
//                   <button
//                     onClick={handleCancelDelete}
//                     style={{
//                       padding: '10px 24px',
//                       borderRadius: '6px',
//                       fontSize: '14px',
//                       fontWeight: 500,
//                       cursor: 'pointer',
//                       backgroundColor: 'white',
//                       color: '#6b7280',
//                       border: '1px solid #d1d5db',
//                       transition: 'all 0.2s',
//                       minWidth: '80px'
//                     }}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleConfirmDelete}
//                     style={{
//                       padding: '10px 24px',
//                       borderRadius: '6px',
//                       fontSize: '14px',
//                       fontWeight: 500,
//                       cursor: 'pointer',
//                       backgroundColor: '#ef4444',
//                       color: 'white',
//                       border: '1px solid #ef4444',
//                       transition: 'all 0.2s',
//                       minWidth: '80px'
//                     }}
//                   >
//                     Delete Account
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           <div style={{ height: '80px' }}></div>
//         </div>
//       </MobileView>

//       <style jsx>{`
//         @keyframes slideInRight {
//           from {
//             transform: translateX(100%);
//             opacity: 0;
//           }
//           to {
//             transform: translateX(0);
//             opacity: 1;
//           }
//         }

//         @keyframes fadeInScale {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default SettingsPage;

import React, { useState } from 'react'
// import { Modal } from 'react-bootstrap';
// import eight from '../../images/daskboard/8.png'
import './dashboardSetting/dashboardSetting.css'
import { FaLock, FaUserAlt } from 'react-icons/fa';
import Acount from './dashboardSetting/Acount';
import Password from './dashboardSetting/Password';
// import Help from './dashboardSetting/Help';
// import ContactUs from './dashboardSetting/ContactUs';
// Width-based views (<=1194px => MobileView) so a landscape iPad (>1194px)
// gets the proper DashboardLayout (fixed sidebar + content offset) instead of
// the UA-based MobileView whose MobileTopBar sidebar overlapped the content.
import { BrowserView, MobileView } from '../../components/responsiveView';
import DashboardLayout from '../../components/DashboardLayout/DashboardLayout';
import { BsTrash } from 'react-icons/bs';
import DeleteAccount from './dashboardSetting/DeleteAccount';
import MobileTopBar from '../../components/common/MobileTopBar';
// import Acount from './Acount';
// import Password from './Password';
// import Help from './Help';
// import ContactUs from './ContactUs';

// interface ISharingOption {
//   dashboardSetting?: boolean; //to make the share symbol into a Neddie Button
//   setDashboardSetting?: (value: boolean) => void; //to make the share button light
//   mobileSettingTab?: number; //to make the share symbol into a Neddie Button
//   setMobileSettingTab?: (value: number) => void; //to make the share button light
// }

// const DashboardSetting: React.FC<ISharingOption> = ({ setDashboardSetting, dashboardSetting  , mobileSettingTab , setMobileSettingTab}) => {
const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState(0)
  return (
    <>
      <BrowserView>
        <DashboardLayout>
          <>
            <div>
              <div className='np-setting-page' >
                <h1 className='manage-marketplace-h2'>Account Settings</h1>
                <div className="mp-s-p-w">
                  <div className="left">
                    <div className="tab-listing">
                      <ul>
                        <li onClick={() => setActiveTab(0)} className={`${activeTab === 0 ? 'active' : ''}`}><span><FaUserAlt /></span>Account</li>
                        <li onClick={() => setActiveTab(1)} className={`${activeTab === 1 ? 'active' : ''}`}><span><FaLock /></span>Password</li>
                        <li onClick={() => setActiveTab(2)} className={`${activeTab === 2 ? 'active' : ''}`}><span><BsTrash /></span>Delete Account</li>
                      </ul>
                    </div>
                  </div>
                  <div className="center"></div>
                  <div className="right">
                    {activeTab === 0 && <Acount />}
                    {activeTab === 1 && <Password />}
                    {activeTab === 2 && <DeleteAccount />}

                  </div>
                </div>
              </div>
            </div>
          </>
        </DashboardLayout>
      </BrowserView>
      <MobileView>
        <MobileTopBar />
        <div>
          <div className='np-setting-page' >
            <h1 className='manage-marketplace-h2'>Account Settings</h1>
            <div className="mp-s-p-w">
              <div className="left">
                <div className="tab-listing">
                  <ul>
                    <li onClick={() => setActiveTab(0)} className={`${activeTab === 0 ? 'active' : ''}`}><span><FaUserAlt /></span>Account</li>
                    <li onClick={() => setActiveTab(1)} className={`${activeTab === 1 ? 'active' : ''}`}><span><FaLock /></span>Password</li>
                    <li onClick={() => setActiveTab(2)} className={`${activeTab === 2 ? 'active' : ''}`}><span><BsTrash /></span>Delete Account</li>
                  </ul>
                </div>
              </div>
              <div className="center"></div>
              <div className="right">
                {activeTab === 0 && <Acount />}
                {activeTab === 1 && <Password />}
                {activeTab === 2 && <DeleteAccount />}

              </div>
            </div>
          </div>
        </div>
      </MobileView>
    </>
  )
}

export default SettingsPage